<h2 mat-dialog-title data-testid="dialog-title">Privacy Notice</h2>

<mat-dialog-content data-testid="dialog-base-content">
  <div class="privacy-notice">
    <p>By clicking "Log in" or accessing the Admin App, you confirm that you have read and agree to the Admin Terms of
      Service and the Game Application Administrator’s Privacy Notice. You understand that access to personal data is
      restricted and subject to approval and audit. Unauthorized access or misuse of player data is strictly prohibited.

    </p>
    <p>By continuing you agree to the <a [routerLink]="['/privacy-policy']" target="_blank" tabindex="-1">admin terms of service</a>.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    data-testid="acknowledge-privacy-button"
    (click)="acknowledge()">
    Log in
  </button>
</mat-dialog-actions>
